import DesignSystem from '../components/DesignSystem';
import outerTheme from '../theme/theme.json';

const instance = new DesignSystem(outerTheme);

export default instance;
